/*
# -----------------------------------------------------------------------------
# Component: index.js
# Author: antonio.ramirez@pst.sg
# Created Date: 29/May/2019
# Comments: Responsible for the state management of Manage Debit Note
# -----------------------------------------------------------------------------
*/
import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters/getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  debitNoteData: {
    branch: '',
    accountNo: '',
    type: '',
    documentNo: '',
    fund: '',
    suffix: '',
    tranMode: '',
    currency: '',
    amount: '',
    gstAmountAE: '',
    gstAmount: '',
    netAmount: '',
    netLocAmountAE: '',
    netLocAmount: '',
    tranDate: '',
    actionName: '',
    printDoc: ''
  },
  debitNoteListing: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
